import { styled } from '@linaria/react'

export const ElLabel = styled.label`
  font-size: var(--font-size-small);
  color: var(--color-grey-500);
`
